import React from "react";
import IconButtons from "../../../../kit/IconButtons";

const ShareAction = (): JSX.Element => <IconButtons.Share />;

export default ShareAction;
